export const BONUS_BUTTON_POPUP_WAS_SHOWN = 'bonusButtonPopupWasShown';
export const BONUS_BUTTON_MODAL_WAS_SHOWN = 'bonusButtonModalWasShown';
